/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchAvailabilityFrequency } from './';
import {
    SourcingSearchAvailabilityFrequencyFromJSON,
    SourcingSearchAvailabilityFrequencyFromJSONTyped,
    SourcingSearchAvailabilityFrequencyToJSON,
} from './';
import type { SourcingSearchExperienceLevel } from './';
import {
    SourcingSearchExperienceLevelFromJSON,
    SourcingSearchExperienceLevelFromJSONTyped,
    SourcingSearchExperienceLevelToJSON,
} from './';
import type { SourcingSearchFilterDailyRate } from './';
import {
    SourcingSearchFilterDailyRateFromJSON,
    SourcingSearchFilterDailyRateFromJSONTyped,
    SourcingSearchFilterDailyRateToJSON,
} from './';
import type { SourcingSearchFilterLocation } from './';
import {
    SourcingSearchFilterLocationFromJSON,
    SourcingSearchFilterLocationFromJSONTyped,
    SourcingSearchFilterLocationToJSON,
} from './';
import type { SourcingSearchFilterOnBackground } from './';
import {
    SourcingSearchFilterOnBackgroundFromJSON,
    SourcingSearchFilterOnBackgroundFromJSONTyped,
    SourcingSearchFilterOnBackgroundToJSON,
} from './';
import type { SourcingSearchFilterOnFunctionalSkills } from './';
import {
    SourcingSearchFilterOnFunctionalSkillsFromJSON,
    SourcingSearchFilterOnFunctionalSkillsFromJSONTyped,
    SourcingSearchFilterOnFunctionalSkillsToJSON,
} from './';
import type { SourcingSearchFilterOnIndustryExpertise } from './';
import {
    SourcingSearchFilterOnIndustryExpertiseFromJSON,
    SourcingSearchFilterOnIndustryExpertiseFromJSONTyped,
    SourcingSearchFilterOnIndustryExpertiseToJSON,
} from './';
import type { SourcingSearchFilterOnKeySkills } from './';
import {
    SourcingSearchFilterOnKeySkillsFromJSON,
    SourcingSearchFilterOnKeySkillsFromJSONTyped,
    SourcingSearchFilterOnKeySkillsToJSON,
} from './';
import type { SourcingSearchFormerEmployerActivityArea } from './';
import {
    SourcingSearchFormerEmployerActivityAreaFromJSON,
    SourcingSearchFormerEmployerActivityAreaFromJSONTyped,
    SourcingSearchFormerEmployerActivityAreaToJSON,
} from './';
import type { SourcingSearchFreelancerVertical } from './';
import {
    SourcingSearchFreelancerVerticalFromJSON,
    SourcingSearchFreelancerVerticalFromJSONTyped,
    SourcingSearchFreelancerVerticalToJSON,
} from './';
import type { SourcingSearchPageContext } from './';
import {
    SourcingSearchPageContextFromJSON,
    SourcingSearchPageContextFromJSONTyped,
    SourcingSearchPageContextToJSON,
} from './';
import type { SourcingSearchProfileAvailability } from './';
import {
    SourcingSearchProfileAvailabilityFromJSON,
    SourcingSearchProfileAvailabilityFromJSONTyped,
    SourcingSearchProfileAvailabilityToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchRequest
 */
export interface SourcingSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRequest
     */
    query: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    languages?: Array<string>;
    /**
     * 
     * @type {Array<SourcingSearchExperienceLevel>}
     * @memberof SourcingSearchRequest
     */
    experienceLevels?: Array<SourcingSearchExperienceLevel>;
    /**
     * 
     * @type {Array<SourcingSearchProfileAvailability>}
     * @memberof SourcingSearchRequest
     */
    availabilities?: Array<SourcingSearchProfileAvailability>;
    /**
     * 
     * @type {Array<SourcingSearchFreelancerVertical>}
     * @memberof SourcingSearchRequest
     */
    acceptedInVerticals?: Array<SourcingSearchFreelancerVertical>;
    /**
     * 
     * @type {SourcingSearchFilterDailyRate}
     * @memberof SourcingSearchRequest
     */
    dailyRate?: SourcingSearchFilterDailyRate;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    locatedInCountries?: Array<string>;
    /**
     * 
     * @type {SourcingSearchFilterLocation}
     * @memberof SourcingSearchRequest
     */
    location?: SourcingSearchFilterLocation;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    professionalBackgrounds?: Array<string>;
    /**
     * 
     * @type {SourcingSearchFilterOnIndustryExpertise}
     * @memberof SourcingSearchRequest
     */
    industryExpertise?: SourcingSearchFilterOnIndustryExpertise;
    /**
     * 
     * @type {SourcingSearchFilterOnFunctionalSkills}
     * @memberof SourcingSearchRequest
     */
    functionalSkills?: SourcingSearchFilterOnFunctionalSkills;
    /**
     * 
     * @type {SourcingSearchFilterOnKeySkills}
     * @memberof SourcingSearchRequest
     */
    keySkills?: SourcingSearchFilterOnKeySkills;
    /**
     * 
     * @type {Array<SourcingSearchAvailabilityFrequency>}
     * @memberof SourcingSearchRequest
     */
    availabilityFrequencies?: Array<SourcingSearchAvailabilityFrequency>;
    /**
     * 
     * @type {Array<SourcingSearchFormerEmployerActivityArea>}
     * @memberof SourcingSearchRequest
     */
    formerEmployerActivityAreas?: Array<SourcingSearchFormerEmployerActivityArea>;
    /**
     * 
     * @type {SourcingSearchFilterOnBackground}
     * @memberof SourcingSearchRequest
     */
    background?: SourcingSearchFilterOnBackground;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchRequest
     */
    hasBeenRecentlyModified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchRequest
     */
    isSuperMalter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchRequest
     */
    isInterestedInInterim?: boolean;
    /**
     * 
     * @type {SourcingSearchPageContext}
     * @memberof SourcingSearchRequest
     */
    pageContext?: SourcingSearchPageContext;
}

/**
 * Check if a given object implements the SourcingSearchRequest interface.
 */
export function instanceOfSourcingSearchRequest(value: object): value is SourcingSearchRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function SourcingSearchRequestFromJSON(json: any): SourcingSearchRequest {
    return SourcingSearchRequestFromJSONTyped(json, false);
}

export function SourcingSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
        'languages': json['languages'] == null ? undefined : json['languages'],
        'experienceLevels': json['experienceLevels'] == null ? undefined : ((json['experienceLevels'] as Array<any>).map(SourcingSearchExperienceLevelFromJSON)),
        'availabilities': json['availabilities'] == null ? undefined : ((json['availabilities'] as Array<any>).map(SourcingSearchProfileAvailabilityFromJSON)),
        'acceptedInVerticals': json['acceptedInVerticals'] == null ? undefined : ((json['acceptedInVerticals'] as Array<any>).map(SourcingSearchFreelancerVerticalFromJSON)),
        'dailyRate': json['dailyRate'] == null ? undefined : SourcingSearchFilterDailyRateFromJSON(json['dailyRate']),
        'locatedInCountries': json['locatedInCountries'] == null ? undefined : json['locatedInCountries'],
        'location': json['location'] == null ? undefined : SourcingSearchFilterLocationFromJSON(json['location']),
        'professionalBackgrounds': json['professionalBackgrounds'] == null ? undefined : json['professionalBackgrounds'],
        'industryExpertise': json['industryExpertise'] == null ? undefined : SourcingSearchFilterOnIndustryExpertiseFromJSON(json['industryExpertise']),
        'functionalSkills': json['functionalSkills'] == null ? undefined : SourcingSearchFilterOnFunctionalSkillsFromJSON(json['functionalSkills']),
        'keySkills': json['keySkills'] == null ? undefined : SourcingSearchFilterOnKeySkillsFromJSON(json['keySkills']),
        'availabilityFrequencies': json['availabilityFrequencies'] == null ? undefined : ((json['availabilityFrequencies'] as Array<any>).map(SourcingSearchAvailabilityFrequencyFromJSON)),
        'formerEmployerActivityAreas': json['formerEmployerActivityAreas'] == null ? undefined : ((json['formerEmployerActivityAreas'] as Array<any>).map(SourcingSearchFormerEmployerActivityAreaFromJSON)),
        'background': json['background'] == null ? undefined : SourcingSearchFilterOnBackgroundFromJSON(json['background']),
        'hasBeenRecentlyModified': json['hasBeenRecentlyModified'] == null ? undefined : json['hasBeenRecentlyModified'],
        'isSuperMalter': json['isSuperMalter'] == null ? undefined : json['isSuperMalter'],
        'isInterestedInInterim': json['isInterestedInInterim'] == null ? undefined : json['isInterestedInInterim'],
        'pageContext': json['pageContext'] == null ? undefined : SourcingSearchPageContextFromJSON(json['pageContext']),
    };
}

export function SourcingSearchRequestToJSON(value?: SourcingSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
        'languages': value['languages'],
        'experienceLevels': value['experienceLevels'] == null ? undefined : ((value['experienceLevels'] as Array<any>).map((v) => SourcingSearchExperienceLevelToJSON(v))),
        'availabilities': value['availabilities'] == null ? undefined : ((value['availabilities'] as Array<any>).map((v) => SourcingSearchProfileAvailabilityToJSON(v))),
        'acceptedInVerticals': value['acceptedInVerticals'] == null ? undefined : ((value['acceptedInVerticals'] as Array<any>).map((v) => SourcingSearchFreelancerVerticalToJSON(v))),
        'dailyRate': SourcingSearchFilterDailyRateToJSON(value['dailyRate']),
        'locatedInCountries': value['locatedInCountries'],
        'location': SourcingSearchFilterLocationToJSON(value['location']),
        'professionalBackgrounds': value['professionalBackgrounds'],
        'industryExpertise': SourcingSearchFilterOnIndustryExpertiseToJSON(value['industryExpertise']),
        'functionalSkills': SourcingSearchFilterOnFunctionalSkillsToJSON(value['functionalSkills']),
        'keySkills': SourcingSearchFilterOnKeySkillsToJSON(value['keySkills']),
        'availabilityFrequencies': value['availabilityFrequencies'] == null ? undefined : ((value['availabilityFrequencies'] as Array<any>).map((v) => SourcingSearchAvailabilityFrequencyToJSON(v))),
        'formerEmployerActivityAreas': value['formerEmployerActivityAreas'] == null ? undefined : ((value['formerEmployerActivityAreas'] as Array<any>).map((v) => SourcingSearchFormerEmployerActivityAreaToJSON(v))),
        'background': SourcingSearchFilterOnBackgroundToJSON(value['background']),
        'hasBeenRecentlyModified': value['hasBeenRecentlyModified'],
        'isSuperMalter': value['isSuperMalter'],
        'isInterestedInInterim': value['isInterestedInInterim'],
        'pageContext': SourcingSearchPageContextToJSON(value['pageContext']),
    };
}

